import React from "react";
import { Navigate } from "react-router-dom";

const WithPrivateRoute = ({ children }) => {
  const token = JSON.parse(
    JSON.parse(localStorage.getItem("persist:evd")).auth
  ).token;

  if (token !== null) {
    return children;
  }

  return <Navigate to="/login" />;
};

export default WithPrivateRoute;
